

import Script from "next/script";

const GoogleSignin = () => {
	return (
		<Script
			strategy="lazyOnload"
			src="https://accounts.google.com/gsi/client"
		/>
	);
};

export default GoogleSignin;
